import * as THREE from 'three';

import { Model } from './Model';

/**
 * Group has children[]
 */
export abstract class GLTFGroup extends Model {
    protected gltf: any;
    public mixer: THREE.AnimationMixer;

    constructor(viewer, gltf, name) {
        super(name, viewer, gltf.scene);
        this.gltf = gltf;
        this.viewer = viewer;
    }

    init() {
        super.init();
        this.sceneUpdate(this.gltf.scene);
        this.gltf.scene.traverse((model) => this.setUpModel(model));

        this.mixer = new THREE.AnimationMixer(this.gltf.scene);
        if (this.gltf.animations.length > 0) {
            this.gltf.animations.forEach((animation) => {
                this.animationUpdate(animation);
            });
        }
    }

    setUpModel(model) {
        if (model.type === 'Mesh') {

            this.meshUpdate(model);
        }
    }

    abstract sceneUpdate(scene);

    abstract meshUpdate(model);

    abstract animationUpdate(animation);

    animate(delta: number) {
        this.mixer.update(delta);
    }
}
